import React from 'react';
import { useObservable } from 'react-use-observable';

import { Divider, Row, Col } from 'antd';

import ColoredFormattedNumber from 'components/ColoredFormattedNumber';
import PermissionHide from 'v2/components/Shared/PermissionHide';
import { affiliateCommissionsService } from 'v2/services/reports/affiliateCommissions';

import { ExportAffiliateComissions } from './Export';

export const Details = () => {
  const [totalItems] = useObservable(() => affiliateCommissionsService.getTotalItems(), []);
  const [totalGain] = useObservable(() => affiliateCommissionsService.getTotalGain(), []);
  const [isLoading] = useObservable(() => affiliateCommissionsService.isLoading(), []);

  const commissionsCount = `${totalItems} ${totalItems > 1 ? 'afiliados' : 'afiliado'}`;

  return (
    <Row
      id='commissions-partners-details'
      className='mb-4 w-full rounded-sm bg-white shadow-[0_1px_0_0_rgba(0,0,0,0.07)]'
      align='middle'
    >
      <Col>
        <div className='px-4 py-2'>
          <span className='text-base font-semibold'>{commissionsCount}</span>
        </div>
      </Col>
      <Divider type='vertical' className='h-10' />
      <Col>
        <div className='px-4 py-2'>
          <span className='text-base font-semibold'>
            Total das Comissões: <ColoredFormattedNumber value={totalGain} format='BRL' />
          </span>
        </div>
      </Col>
      <Divider type='vertical' className='h-10' />
      <PermissionHide action={'myeduzz:reports:exportar'}>
        <Col className='ml-auto'>{!isLoading && <ExportAffiliateComissions />}</Col>
      </PermissionHide>
    </Row>
  );
};
